import {TFunction} from "i18next";
import {MUIDataTableColumn} from "mui-datatables";
import React from "react";
import {formatValidity, ValidityInfo} from "../../../shared/technical/domain/ValidityInfo";
import {formatQuotaLicenses, formatUserQuotaLicense, QuotaLicense, ServerLicense, UserQuotaLicense} from "./License";

export function licenseColumns(t: TFunction): MUIDataTableColumn[] {
  return [
    {
      name: 'company', label: t('License.company'), options: {
        filter: false,
        searchable: true,
        customBodyRender: (company) => (
          company ? <p style={{margin: 'unset'}}>{company.name}</p> : <p />
        ),
      }
    },
    {
      name: 'validityInfo', label: t('License.validityInfo'), options: {
        filter: false,
        customBodyRender: (validityInfo: ValidityInfo) => (
          validityInfo ? <p style={{margin: 'unset'}}>{formatValidity(validityInfo, t)}</p> : <p />
        ),
      }
    },
    {
      name: 'serverLicense', label: t('License.serverLicense.title'), options: {
        filter: false,
        customBodyRender: (serverLicense: ServerLicense) => (
          serverLicense ? <p style={{margin: 'unset'}}>{serverLicense.name}</p> : <p />
        ),
      }
    },
    {
      name: 'quotaLicenses', label: t('License.quotaLicense.title'), options: {
        filter: false,
        customBodyRender: (quotaLicenses?: QuotaLicense[]) => (
          quotaLicenses ? <p style={{margin: 'unset'}}>{formatQuotaLicenses(quotaLicenses)}</p> : <p />
        ),
      }
    },
    {
      name: 'userQuotaLicense', label: t('License.userQuotaLicense.title'), options: {
        filter: false,
        customBodyRender: (userQuotaLicense?: UserQuotaLicense) => (
          userQuotaLicense ? <p style={{margin: 'unset'}}>{formatUserQuotaLicense(userQuotaLicense)}</p> : <p />
        ),
      }
    },
  ];
}
